// Theme: chrome-orchid
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'chrome-orchid',
  name: 'CHROME ORCHID',
  tagline: 'CHROME ORCHID',
  description: 'Indigo metalizado com elegancia fria e floral.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#10254F', '#1A3570', '#C4B5FD', '#F3F7FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 12px 32px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 12px 32px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-chrome-orchid'
  },
  colorVars: {
    '--accent': '#C4B5FD',
    '--accent-foreground': '#10254F',
    '--background': '#10254F',
    '--border': '#3A65C0',
    '--card': '#1A3570',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3F7FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#10254F',
    '--foreground': '#F3F7FF',
    '--hold-fill': '#C4B5FD',
    '--input': '#3A65C0',
    '--modal-bg': '#10254F',
    '--modal-border': '#3A65C0',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 32px rgba(0, 0, 0, 0.24)',
    '--muted': '#3A65C0',
    '--muted-foreground': '#F3F7FF',
    '--nav-active': '#C4B5FD',
    '--nav-bg': '#1A3570',
    '--popover': '#1A3570',
    '--popover-foreground': '#F3F7FF',
    '--primary': '#C4B5FD',
    '--primary-foreground': '#10254F',
    '--ring': '#C4B5FD',
    '--secondary': '#3A65C0',
    '--secondary-foreground': '#F3F7FF',
    '--streak': '#C4B5FD',
    '--success': '#22c55e',
    '--success-foreground': '#10254F',
    '--xp': '#C4B5FD',
    '--xp-bg': '#1A3570'
  },
  resolvedVars: {
    '--accent': '#C4B5FD',
    '--accent-foreground': '#10254F',
    '--accent-foreground-hsl': '220 66% 19%',
    '--accent-foreground-oklch': 'from #10254F l c h',
    '--accent-hsl': '252 95% 85%',
    '--accent-oklch': 'from #C4B5FD l c h',
    '--background': '#10254F',
    '--background-hsl': '220 66% 19%',
    '--background-oklch': 'from #10254F l c h',
    '--border': '#3A65C0',
    '--border-hsl': '221 54% 49%',
    '--border-oklch': 'from #3A65C0 l c h',
    '--border-w': '1px',
    '--card': '#1A3570',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3F7FF',
    '--card-foreground-hsl': '220 100% 98%',
    '--card-foreground-oklch': 'from #F3F7FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '221 62% 27%',
    '--card-oklch': 'from #1A3570 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#10254F',
    '--destructive-foreground-hsl': '220 66% 19%',
    '--destructive-foreground-oklch': 'from #10254F l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3F7FF',
    '--foreground-hsl': '220 100% 98%',
    '--foreground-oklch': 'from #F3F7FF l c h',
    '--hold-fill': '#C4B5FD',
    '--hold-fill-hsl': '252 95% 85%',
    '--hold-fill-oklch': 'from #C4B5FD l c h',
    '--input': '#3A65C0',
    '--input-hsl': '221 54% 49%',
    '--input-oklch': 'from #3A65C0 l c h',
    '--modal-bg': '#10254F',
    '--modal-bg-hsl': '220 66% 19%',
    '--modal-bg-oklch': 'from #10254F l c h',
    '--modal-border': '#3A65C0',
    '--modal-border-hsl': '221 54% 49%',
    '--modal-border-oklch': 'from #3A65C0 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 32px rgba(0, 0, 0, 0.24)',
    '--muted': '#3A65C0',
    '--muted-foreground': '#F3F7FF',
    '--muted-foreground-hsl': '220 100% 98%',
    '--muted-foreground-oklch': 'from #F3F7FF l c h',
    '--muted-hsl': '221 54% 49%',
    '--muted-oklch': 'from #3A65C0 l c h',
    '--nav-active': '#C4B5FD',
    '--nav-active-hsl': '252 95% 85%',
    '--nav-active-oklch': 'from #C4B5FD l c h',
    '--nav-bg': '#1A3570',
    '--nav-bg-hsl': '221 62% 27%',
    '--nav-bg-oklch': 'from #1A3570 l c h',
    '--popover': '#1A3570',
    '--popover-foreground': '#F3F7FF',
    '--popover-foreground-hsl': '220 100% 98%',
    '--popover-foreground-oklch': 'from #F3F7FF l c h',
    '--popover-hsl': '221 62% 27%',
    '--popover-oklch': 'from #1A3570 l c h',
    '--primary': '#C4B5FD',
    '--primary-foreground': '#10254F',
    '--primary-foreground-hsl': '220 66% 19%',
    '--primary-foreground-oklch': 'from #10254F l c h',
    '--primary-hsl': '252 95% 85%',
    '--primary-oklch': 'from #C4B5FD l c h',
    '--radius': '10px',
    '--ring': '#C4B5FD',
    '--ring-hsl': '252 95% 85%',
    '--ring-oklch': 'from #C4B5FD l c h',
    '--secondary': '#3A65C0',
    '--secondary-foreground': '#F3F7FF',
    '--secondary-foreground-hsl': '220 100% 98%',
    '--secondary-foreground-oklch': 'from #F3F7FF l c h',
    '--secondary-hsl': '221 54% 49%',
    '--secondary-oklch': 'from #3A65C0 l c h',
    '--shadow-card': '0 12px 32px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 12px 32px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#C4B5FD',
    '--streak-hsl': '252 95% 85%',
    '--streak-oklch': 'from #C4B5FD l c h',
    '--success': '#22c55e',
    '--success-foreground': '#10254F',
    '--success-foreground-hsl': '220 66% 19%',
    '--success-foreground-oklch': 'from #10254F l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(252 95% 85% / 0.15)',
    '--xp': '#C4B5FD',
    '--xp-bg': '#1A3570',
    '--xp-bg-hsl': '221 62% 27%',
    '--xp-bg-oklch': 'from #1A3570 l c h',
    '--xp-hsl': '252 95% 85%',
    '--xp-oklch': 'from #C4B5FD l c h'
  }
}
